import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import {RouteTransferTypeValuesType} from "@Route/features/transportType/types/routeTransferType.type";
import CompanyType from "@SearchResults/types/company/Company.type";
import RouteType from "@Route/types/Route.type";

type GetUniqueStationsProps = {
    searchData: SearchResultsRtkQueryResponseType,
    tab: RouteTransferTypeValuesType,
    filteredRoutes?: RouteType[]  // Optional filtered routes to use instead of raw routes
}
export default function getUniqueCompaniesForActiveTab(props: GetUniqueStationsProps): CompanyType[] {
    // Use filtered routes if provided, otherwise fall back to raw routes
    const routesToUse = props.filteredRoutes || props.searchData.result.singleRoutes[props.tab]
    const companyIds = routesToUse.map((route) => route.companyId);
    const {companies} = props.searchData.result

    return Object.values(companies).filter((company) => (companyIds.includes(company.id.toString())))
}